import ContainerEditProfessional from './ContainerEditProfessional';

export default props => {
    return <ContainerEditProfessional />;
};
